import de from './de';

export default {
  de,
};
